<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">Ajouter les details du certificat d'immatriculation</h4>
    </div>
    <div class="modal-body">
      <div class="row equal" style="margin-bottom: 20px;">
        <div class="col-md-6 col-lg-6">
          <div v-if="model.carRegistrationBase64 && model.carRegistrationBase64.includes('application/pdf')" style="width: 100%; height: 100%;">
            <object :data="model.carRegistrationBase64" style="width: 100%; height: 100%;"></object>
          </div>
          <div v-else-if="model.carRegistrationBase64" style="width: 100%; height: 70%;">
            <img :src="model.carRegistrationBase64" id="imageM" alt="" style="display: none;">
          </div>
          <h4 v-else>Il faut ajouter le certificat d'immatriculation !</h4>
        </div>
        <div class="col-md-6 col-lg-6">
          <!--N° Immatriculation (A)			AA-123-AA-->
          <div>
            <h4>N° Immatriculation (A)</h4>
            <input type="text"
                   placeholder="N° Immatriculation (A)"
                   class="form-control"
                   v-model="carRegistrationData.licensePlate">
          </div>

          <!--Date de 1ère immatriculation (B)		XX/XX/XXXX-->
          <div>
            <h4>Date de 1ère immatriculation (B)</h4>
            <input type="date"
                   placeholder="Date de 1ère immatriculation (B)"
                   class="form-control"
                   v-model="carRegistrationData.releaseDate">
          </div>

          <!--Prénom (C1)			champs libre-->
          <div>
            <h4>Prénom (C1)</h4>
            <input type="text"
                   placeholder="Prénom (C1)"
                   class="form-control"
                   v-model="carRegistrationData.firstNameOwner">
          </div>

          <!--NOM (C1)			champs libre-->
          <div>
            <h4>NOM (C1)</h4>
            <input type="text"
                   placeholder="NOM (C1)"
                   class="form-control"
                   v-model="carRegistrationData.lastNameOwner">
          </div>

          <hr>

          <!--Adresse			champs libre-->
          <div>
            <h4>Adresse</h4>
            <input type="text"
                   placeholder="Adresse"
                   class="form-control"
                   v-model="carRegistrationData.address">
          </div>

          <!--Code postal				numéro à 6 chiffres-->
          <div>
            <h4>Code postal</h4>
            <input type="number"
                   placeholder="Code postal"
                   class="form-control"
                   v-model="carRegistrationData.zipCode">
          </div>

          <!--Commune				champs libre-->
          <div>
            <h4>Commune</h4>
            <input type="text"
                   placeholder="Commune"
                   class="form-control"
                   v-model="carRegistrationData.city">
          </div>

          <hr>

          <!--Type, variante, version (D.2)		champs libre-->
          <div>
            <h4>Type, variante, version (D.2)</h4>
            <input type="text"
                   placeholder="Type, variante, version (D.2)"
                   class="form-control"
                   v-model="carRegistrationData.typeVariantVersion">
          </div>

          <!--CNIT (D.2.1)				champs libre-->
          <div>
            <h4>CNIT (D.2.1)</h4>
            <input type="text"
                   placeholder="CNIT (D.2.1)"
                   class="form-control"
                   v-model="carRegistrationData.minesType">
          </div>

          <!--Dénomination commerciale (D.3)		champs libre-->
          <div>
            <h4>Dénomination commerciale (D.3)</h4>
            <input type="text"
                   placeholder="Dénomination commerciale (D.3)"
                   class="form-control"
                   v-model="carRegistrationData.denomCommercial">
          </div>

          <!--N° identification du véhicule (E)		17caractères-->
          <div>
            <h4>N° identification du véhicule (E)</h4>
            <input type="text"
                   placeholder="N° identification du véhicule (E)"
                   class="form-control"
                   v-model="carRegistrationData.vehicleIdentification">
          </div>

          <!--Genre national (J.1)			VP ou CTTE ou VASP-->
          <div>
            <h4>Genre national (J.1)</h4>
            <select class="form-control" v-model="carRegistrationData.nationalGender">
              <option disabled value="">Genre national (J.1)</option>
              <option>VP</option>
              <option>CTTE</option>
              <option>VASP</option>
            </select>
          </div>

          <!--Taux du CO2 (V.7)			nombre-->
          <div>
            <h4>Taux du CO2 (V.7)</h4>
            <input type="number"
                   placeholder="Taux du CO2 (V.7)"
                   class="form-control"
                   v-model="carRegistrationData.rateCO2">
          </div>

          <!--Date du certificat d’immatriculation (I)	XX/XX/XXXX-->
          <div>
            <h4>Date du certificat d’immatriculation (I)</h4>
            <input type="date"
                   placeholder="Date du certificat d’immatriculation (I)"
                   class="form-control"
                   v-model="carRegistrationData.registrationDate">
          </div>

          <!--Numéro de formule			2019A2A2A2A-->
          <div>
            <h4>Numéro de formule</h4>
            <input type="text"
                   placeholder="Numéro de formule"
                   class="form-control"
                   v-model="carRegistrationData.formulaNumber">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-center">
      <button type="button"
              class="btn btn-default"
              @click="closeModal">Annuler</button>
      <button type="button"
              class="btn btn-primary"
              @click="onSubmit">Ajouter</button>
    </div>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import store from '../../config/store'
  import Viewer from 'viewerjs'

  export default {
    data: () => ({
      store,
      carRegistrationData: {
        carId: '',
        licensePlate: '',
        releaseDate: '',
        firstNameOwner: '',
        lastNameOwner: '',
        address: '',
        zipCode: '',
        city: '',
        typeVariantVersion: '',
        minesType: '',
        denomCommercial: '',
        vehicleIdentification: '',
        nationalGender: '',
        rateCO2: '',
        registrationDate: '',
        formulaNumber: '',
      }
    }),

    computed: {
      model () {
        return store.modal.dataModel
      },
      formIsCompleted () {
        if(
            !this.model.carRegistrationBase64 ||
            !this.carRegistrationData.licensePlate ||
            !this.carRegistrationData.releaseDate ||
            !this.carRegistrationData.firstNameOwner ||
            !this.carRegistrationData.lastNameOwner ||
            !this.carRegistrationData.address ||
            !this.carRegistrationData.zipCode ||
            !this.carRegistrationData.city ||
            !this.carRegistrationData.typeVariantVersion ||
            !this.carRegistrationData.minesType ||
            !this.carRegistrationData.denomCommercial ||
            !this.carRegistrationData.vehicleIdentification ||
            !this.carRegistrationData.nationalGender ||
            !this.carRegistrationData.rateCO2 ||
            !this.carRegistrationData.registrationDate ||
            !this.carRegistrationData.formulaNumber
        ){
            return false
        } else {
            return true
        }
      },
      image () {
          if(this.model.carRegistrationBase64 && !this.model.carRegistrationBase64.includes('application/pdf')){
              return this.model.carRegistrationBase64
          } else {
              return null
          }
      },
      isImage () {
          if(this.image && typeof this.image === 'string' && this.image.includes('image/')) {
              this.initImageViewer()
              return true
          } else {
              return false
          }
      }
    },

    methods: {
      onSubmit () {
        this.$bus.$emit('car-registration-data-' + this.model.document.query, {'carRegistrationData': this.carRegistrationData, 'formIsCompleted': this.formIsCompleted })
        this.closeModal()
      },
      initImageViewer () {
          // View an image
          const imageElement = document.getElementById('imageM')
          imageElement.src = this.model.carRegistrationBase64

          const viewer = new Viewer(imageElement, {
              inline: true,
              title: false,
              button: false,
              navbar: false,
              toolbar: {
                  zoomOut: { show: 1, size: "large"},
                  zoomIn: { show: 1, size: "large"},
                  oneToOne: 0,
                  reset: { show: 1, size: "large"},
                  prev: 0,
                  play: 0,
                  next: 0,
                  rotateLeft: { show: 1, size: "large"},
                  rotateRight: { show: 1, size: "large"},
                  flipHorizontal: 0,
                  flipVertical: 0,
              },
          });

          viewer.show()
      }
    },

    mounted () {
        // Populate form

        if(this.model.tempValuesForCarRegistrationDataModal){
            this.carRegistrationData.carId = this.model.tempValuesForCarRegistrationDataModal.carId
            this.carRegistrationData.licensePlate = this.model.tempValuesForCarRegistrationDataModal.licensePlate

            this.carRegistrationData.releaseDate = moment(this.model.tempValuesForCarRegistrationDataModal.releaseDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            this.carRegistrationData.registrationDate = moment(this.model.tempValuesForCarRegistrationDataModal.registrationDate, "DD-MM-YYYY").format("YYYY-MM-DD")

            this.carRegistrationData.typeVariantVersion = this.model.tempValuesForCarRegistrationDataModal.typeVariantVersion
            this.carRegistrationData.minesType = this.model.tempValuesForCarRegistrationDataModal.minesType
            this.carRegistrationData.denomCommercial = this.model.tempValuesForCarRegistrationDataModal.denomCommercial
            this.carRegistrationData.vehicleIdentification = this.model.tempValuesForCarRegistrationDataModal.vehicleIdentification
            this.carRegistrationData.nationalGender = this.model.tempValuesForCarRegistrationDataModal.nationalGender
            this.carRegistrationData.rateCO2 = this.model.tempValuesForCarRegistrationDataModal.rateCO2
            this.carRegistrationData.formulaNumber = this.model.tempValuesForCarRegistrationDataModal.formulaNumber

            this.carRegistrationData.firstNameOwner = this.model.tempValuesForCarRegistrationDataModal.firstNameOwner
            this.carRegistrationData.lastNameOwner = this.model.tempValuesForCarRegistrationDataModal.lastNameOwner
            this.carRegistrationData.address = this.model.tempValuesForCarRegistrationDataModal.address
            this.carRegistrationData.zipCode = this.model.tempValuesForCarRegistrationDataModal.zipCode
            this.carRegistrationData.city = this.model.tempValuesForCarRegistrationDataModal.city
        } else {
            this.carRegistrationData.carId = this.model.command.vehicule[0].id
            this.carRegistrationData.licensePlate = this.model.command.vehicule[0].licensePlate

            this.carRegistrationData.releaseDate = moment(this.model.command.vehicule[0].releaseDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            this.carRegistrationData.registrationDate = moment(this.model.command.vehicule[0].registrationDate, "DD-MM-YYYY").format("YYYY-MM-DD")

            this.carRegistrationData.typeVariantVersion = this.model.command.vehicule[0].typeVariantVersion
            this.carRegistrationData.minesType = this.model.command.vehicule[0].minesType
            this.carRegistrationData.denomCommercial = this.model.command.vehicule[0].denomCommercial
            this.carRegistrationData.vehicleIdentification = this.model.command.vehicule[0].vehicleIdentification
            this.carRegistrationData.nationalGender = this.model.command.vehicule[0].nationalGender
            this.carRegistrationData.rateCO2 = this.model.command.vehicule[0].rateCO2
            this.carRegistrationData.formulaNumber = this.model.command.vehicule[0].formulaNumber

            if(this.model.command.vehicule[0].infoCG.firstNameOwner){
                this.carRegistrationData.firstNameOwner = this.model.command.vehicule[0].infoCG.firstNameOwner
            } else {
                this.carRegistrationData.firstNameOwner = this.model.dataForValidationPopup.owner.firstName
            }

            if(this.model.command.vehicule[0].infoCG.lastNameOwner){
                this.carRegistrationData.lastNameOwner = this.model.command.vehicule[0].infoCG.lastNameOwner
            } else {
                this.carRegistrationData.lastNameOwner = this.model.dataForValidationPopup.owner.lastName
            }

            this.carRegistrationData.address = this.model.command.vehicule[0].infoCG.address.address
            this.carRegistrationData.zipCode = this.model.command.vehicule[0].infoCG.address.zipCode
            this.carRegistrationData.city = this.model.command.vehicule[0].infoCG.address.city
        }

        // Init Image Viewer
        if(this.image && typeof this.image === 'string' && this.image.includes('image/')) {
            this.initImageViewer()
        }
    },

  }
</script>

<style>
  .row.equal {
    display: flex;
    flex-wrap: wrap;
  }

  .equal > div[class*='col-'] {
    display: flex;
    flex-direction: column;
  }

</style>
